import axios from 'axios'

const localStorage = typeof window !== 'undefined' && window.localStorage
const config = {
  baseURL: process.env.NEXT_PUBLIC_BACKEND_HOST,
  withCredentials: false,
  responseType: 'json',

  transformResponse: [(data) => data],
  maxRedirects: 5, // default
  maxContentLength: Infinity,
  validateStatus: (status) => {
    return status >= 200 && status < 500 // default
  },
  xsrfCookieName: 'XSRF-TOKEN', // default
  xsrfHeaderName: 'X-XSRF-TOKEN', // default
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 0
}

const config2 = { ...config }
// config2.baseURL = APIURL.BASE_URL_V2
const apiInstance_v2 = axios.create(config2)

function get_v2 (apiURL, options = {}) {
  // console.log(config2)
  if (localStorage.token) {
    apiInstance_v2.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.token
    // console.log(apiInstance_v2.defaults.headers.common['Authorization'])
  }
  return (
    apiInstance_v2.get(apiURL, options).then(response => {
      return handleResponse(response)
    }).catch(error => {
      return handleError(error)
    })
  )
}

function post_v2 (apiURL, payload, headers = {}) {
  if (localStorage.token) {
    apiInstance_v2.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.token
  }
  return (
    apiInstance_v2.post(apiURL, payload).then(response => {
      return handleResponse(response)
    }).catch(error => {
      return handleError(error)
    })
  )
}

function put_v2 (apiURL, payload, options = {}) {
  if (localStorage.token) {
    apiInstance_v2.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.token
    // console.log(apiInstance_v2.defaults.headers.common['Authorization'])
  }

  return (
    apiInstance_v2.put(apiURL, payload, options).then(response => {
      return handleResponse(response)
    }).catch(error => {
      return handleError(error)
    })
  )
}

function handleResponse (response) {
  let resData = {}
  if (typeof response.data === 'object') {
    if (response.status === 404) {
      resData = { status: 'failure', statusCode: 404, message: response.statusText }
    } else {
      resData = response.data
    }
  } else {
    resData = JSON.parse(response.data)
  }
  return resData
}

function handleError (error) {
  if (error.message === 'Network Error') {
    return { status: 'failure', statusCode: 500, message: error.message }
  } else if (error.message && !error.status) {
    return { status: 'failure', statusCode: 503, message: error.message }
  } else if (error.response.data) {
    return error.response.data
  } else if (error.response) {
    return { status: 'failure', statusCode: error.response.status, message: error.message }
  } else if (error.request) {
    return { status: 'failure', statusCode: error.status, message: error.message }
  } else {
    return { status: 'failure', statusCode: error.status, message: error.message }
  }
}

const services = {
  get_v2,
  put_v2,
  post_v2
}

export default services
